import React from 'react';
import DynamicAccountBankSelect from './Dynamic';

const DynamicAccountBankSelectField = ({
    input,
    onChange,
    label,
    disabled,
    oId,
}) => {
    const { value: inputValue, onChange: inputOnChange } = input;
    const handleChange = (value) => {
        inputOnChange(value);
        if (onChange) {
            onChange(value);
        }
    };
    return (
        <DynamicAccountBankSelect
            defaultValue={inputValue}
            label={label}
            onChange={handleChange}
            disabled={disabled}
            oId={oId}
        />
    );
};

DynamicAccountBankSelectField.propTypes = {};

export default DynamicAccountBankSelectField;
